import React, { Component } from 'react';

export default class PinIcon extends Component {
    render() {
        return (
            <svg version="1.1" x="0px" y="0px" width="15px" viewBox="0 0 150.5 182.5">
                <path
                    className="st0"
                    fill="#333333"
                    d="M74.6,182.5c-5,0-9.9-2-13.5-5.5c-12.8-13-28.9-30.1-41.1-48C6.6,108.9,0,91.2,0,74.8C0,33.5,33.8,0,75.2,0 s75.2,33.5,75.2,74.8c0.2,34-31.8,68.9-57.6,97c-1.4,1.5-2.8,3-4.2,4.5c-3.6,3.9-8.4,6.1-13.7,6.2C74.9,182.5,74.8,182.5,74.6,182.5 z M75.2,11C39.8,11,11,39.6,11,74.8c0,31.3,29.3,65.3,58,94.5c1.5,1.5,3.6,2.4,5.8,2.3c2.2,0,4.3-1,5.8-2.6c1.4-1.5,2.8-3,4.2-4.5 c24.5-26.6,54.9-59.8,54.7-89.5C139.5,39.6,110.7,11,75.2,11z M75.2,107.6c-19.1,0-34.6-15.4-34.6-34.3S56.2,39,75.2,39 c19.1,0,34.6,15.4,34.6,34.3S94.3,107.6,75.2,107.6z M75.2,50c-13,0-23.6,10.5-23.6,23.3s10.6,23.3,23.6,23.3 c13,0,23.6-10.5,23.6-23.3S88.2,50,75.2,50z"
                />
            </svg>
        );
    }
}
